// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import PropTypes from 'prop-types';

const Column = () => {
  return null;
};

Column.propTypes = {
  dataKey: PropTypes.string.isRequired,
  headerOverride: PropTypes.element,
  label: PropTypes.string,
  format: PropTypes.object,
  headerIcon: PropTypes.string,
  totalValue: PropTypes.node,
  sortable: PropTypes.bool,
  keepMobileLabel: PropTypes.bool,
  cellRender: PropTypes.func,
  labelRender: PropTypes.func,
  totalRender: PropTypes.func,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  fontColor: PropTypes.string,
  cellClassName: PropTypes.string,
  justifyContent: PropTypes.oneOf(['left', 'center', 'right']),
  width: PropTypes.number,
  maxWidth: PropTypes.number,
  flexWidth: PropTypes.bool,
  tooltip: PropTypes.any,
  isShowing: PropTypes.bool,
  //  Added to distinguish columns that won't be in the column selector through
  //  visibleColumns prop on table but still need to be rendered
  fixed: PropTypes.bool,
  noMargin: PropTypes.bool,
  flags: PropTypes.any, // TODO
  noLineClamp: PropTypes.bool,
};

Column.defaultProps = {
  headerOverride: null,
  label: '',
  headerIcon: null,
  format: null,
  sortable: false,
  cellRender: null,
  labelRender: null,
  tooltip: null,
  className: null,
  labelClassName: null,
  cellClassName: null,
  maxWidth: null,
  minWidth: null,
  width: 125,
  flexWidth: false,
  isShowing: true,
  fixed: false,
  noMargin: false,
  flags: null,
  noLineClamp: false,
};

export default Column;
